// @flow
import ProductListSlider from 'fg-frontend/components/ProductListSlider';
import EshopPhotogallery from 'fg-frontend/components/EshopPhotogallery';
import EshopModel3D from 'fg-frontend/components/EshopModel3D';
import EshopImageMagnify from 'fg-frontend/components/EshopImageMagnify';
import EshopGalleryPopup from 'fg-frontend/components/EshopGalleryPopup';
import EshopOrderForm from 'fg-frontend/components/EshopOrderForm';

//ESHOP: fulltextovy naseptavac, povolte, pokud je aktivni fulltext feature
import EshopFulltextAutocomplete from 'fg-frontend/src/components/EshopFulltextAutocomplete';

// ESHOP: detail produktu, komponenta productDetailVariantForm - povolte, pokud je na komponente nastaveno metadato <enableVariantStockHandler>true</enableVariantStockHandler>
import EshopVariantStockHandler from './eshop/EshopVariantStockHandler';

// ESHOP: vyber pobocky v ramci vybranych doprav - povolte, kdyz mate na widgetu pro vyber dopravy nastavene metadato <enableBranchPicker>true</enableBranchPicker>
import BranchPicker from 'fg-frontend/src/components/BranchPicker';

// ESHOP: Handler komponenta pro pridani/odebrani produktu z oblibenych/porovnavani (odeberte, pokud na projektu nepouzivate ani oblibene ani porovnavani)
import EshopUserToolsHandler from './components/configurator/EshopUserToolsHandler';

// ESHOP: ovládání modálního okna pro popis variantní barvy
import ColorDescriptionModal from './components/ColorDescriptionModal';

export default (props) => {
    switch (props.decorator || props.is) {
        case 'EshopPhotogallery':
            return EshopPhotogallery;
        case 'EshopModel3D':
            return EshopModel3D;
        case 'EshopImageMagnify':
            return EshopImageMagnify;
        case 'EshopGalleryPopup':
            return EshopGalleryPopup;
        case 'EshopOrderForm':
            return EshopOrderForm;
        case 'EshopFulltextAutocomplete':
            return EshopFulltextAutocomplete;
        case 'ProductListSlider':
            return ProductListSlider;
        case 'BranchPicker':
            return BranchPicker;
        case 'ColorDescriptionModal':
            return ColorDescriptionModal;
        case 'EshopVariantStockHandler':
            return EshopVariantStockHandler;
        case 'EshopUserToolsHandler':
            return EshopUserToolsHandler;
    }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureConfiguratorEshopComponents.js